import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LoginForm } from '@/components/layout/LoginForm';
import { useAuth } from '@/hooks/useAuth';

export function LoginPage() {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Full path including query string and hash, set by AuthGate.
  const from = (location.state as { from?: string } | null)?.from ?? '/dashboard';

  if (!isLoading && user) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-br from-background to-secondary/40 p-6">
      <Card className="w-full max-w-sm">
        <CardHeader className="space-y-3">
          <div className="grid h-10 w-10 place-items-center rounded-md bg-primary/10 text-primary">
            <Sparkles className="h-5 w-5" />
          </div>
          <CardTitle className="text-xl">Command Room</CardTitle>
          <CardDescription>Sign in to manage the Multi-Agent System.</CardDescription>
        </CardHeader>
        <CardContent>
          <LoginForm onSuccess={() => navigate(from, { replace: true })} />
        </CardContent>
      </Card>
    </div>
  );
}
